module.exports = __webpack_public_path__ + "img/关注每ico.6f8cdebc.png";